export type CostCenterTypeStatusDto =
  | string
  | {
      code?: string;
      name?: string;
      label?: string;
      value?: string;
      tone?: string;
    };

export type CostCenterTypeDto = {
  uuid: string;
  name: string;
  description: string | null;
  projectRelated: boolean;
  status: CostCenterTypeStatusDto;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type CostCenterTypeRequest = {
  name: string;
  description: string | null;
  projectRelated: boolean;
};

export type CostCenterTypeListQuery = {
  name?: string;
  description?: string;
  projectRelated?: boolean;
  enabled?: boolean;
  page?: number;
  size?: number;
  sort?: string;
};

export type CostCenterTypeListResult = {
  items: CostCenterTypeDto[];
  total: number;
};

export type CostCenterTypeStatusLabel = 'Activo' | 'Inactivo';

export function costCenterTypeEnabled(dto: CostCenterTypeDto): boolean {
  return costCenterTypeStatusLabel(dto) === 'Activo';
}

export function costCenterTypeStatusLabel(
  dto: CostCenterTypeDto,
): CostCenterTypeStatusLabel {
  const status = dto.status;
  if (status && typeof status === 'object') {
    if (status.tone === 'danger') return 'Inactivo';
    if (status.tone === 'success') return 'Activo';
    return classifyStatusName(status.name ?? status.label ?? status.code ?? '');
  }
  if (typeof status === 'string') {
    return classifyStatusName(status);
  }
  if (typeof dto.enabled === 'boolean') {
    return dto.enabled ? 'Activo' : 'Inactivo';
  }
  return 'Activo';
}

function classifyStatusName(raw: string): CostCenterTypeStatusLabel {
  const normalized = raw.trim().toLowerCase();
  if (
    normalized === 'inactivo' ||
    normalized === 'inactive' ||
    normalized === 'disabled' ||
    normalized.startsWith('inactiv')
  ) {
    return 'Inactivo';
  }
  return 'Activo';
}
